import { useContext } from "react";
import { TrainersService } from "../services/trainers.service";
import { AuthContext } from "@modules/auth/contexts/auth-plus.context";

export const useTrainers = () => {
  const trainerService = new TrainersService();
  const { auth, setAuth, logout } = useContext(AuthContext);

  const getTrainers = async (
    page: number = 1,
    verified?: boolean,
    sort?: 1 | -1,
  ) => {
    return await trainerService.getTrainers(
      auth,
      setAuth,
      logout,
      page,
      verified,
      sort,
    );
  };

  const deleteTrainer = async (id: string) => {
    return await trainerService.deleteTrainer(auth, setAuth, logout, id);
  };

  return {
    getTrainers,
    deleteTrainer,
  };
};
